const MODULE = "MERCHANT_FEES";
const action = action => `${MODULE}_${action}`;

export const merchantFeesConstants = {
	EDIT_MERCHANT_FEES_REQUEST: action("EDIT_REQUEST"),
	EDIT_MERCHANT_FEES_SUCCESS: action("EDIT_SUCCESS"),
	EDIT_MERCHANT_FEES_ERROR: action("EDIT_ERROR"),
};
